<template>
  <vis-page-login v-if="settings.adminLogin" :state="state" />
  <s-page-login v-else :state="state" />
</template>

<script>
import { createSettings } from "../utils/settings";
import { loginMixin } from "@ba/visary-account-common-vue";

import VisPageLogin from "./vis-page-login";
import SPageLogin from "./smena/s-page-login";

export default {
  name: "page-login",
  components: { SPageLogin, VisPageLogin },
  mixins: [loginMixin],
  data() {
    return {
      settings: createSettings()
    };
  },
  watch: {
    loginInfo() {
      this.settings = createSettings(this.loginInfo?.clientId);
    }
  }
};
</script>
